import { EnvironmentSettings } from 'mi.common.settings.environment.contract';
export class EnvironmentService {
    static getEnvironmentName() {
        return window.mitchell.environment;
    }
    static isEnvironmentName(environmentName) {
        const env = EnvironmentService.getEnvironmentName();
        return env != null && env.toUpperCase() === (environmentName === null || environmentName === void 0 ? void 0 : environmentName.toUpperCase());
    }
    static getEnvironment() {
        return EnvironmentSettings.get(EnvironmentService.getEnvironmentName());
    }
    static getApplicationName() {
        return EnvironmentSettings.ApplicationName;
    }
    static setApplicationName(name) {
        EnvironmentSettings.ApplicationName = name;
    }
}
//# sourceMappingURL=EnvironmentService.js.map